/**
 * interface defines tracking numbers
 */
export interface TrackingNumber {
  slug: string;
  number: string;
  status: string;
  url: string;
  mode?: string;
  has_aftership?: boolean;
}

// constant for unknown slug
export const UNKNOWN_SLUG = 'unknown';
